import { Formik } from 'formik';
import { Helmet } from 'react-helmet';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { AuthAction } from 'src/actions/auth.action';
import * as Yup from 'yup';

import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
} from '@material-ui/core';

const Login = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate();
  return (
    <>
      <Helmet>
        <title>Login</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'center'
        }}
      >
        <Container maxWidth="sm">
          <Formik
            initialValues={{
              username: '',
              password: ''
            }}
            validationSchema={Yup.object().shape({
              username: Yup.string().max(255).required('Username is required'),
              password: Yup.string().max(255).required('Password is required')
            })}
            onSubmit={(values) => {
              dispatch(AuthAction.login(navigate, values));
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values
            }) => (
              <form className='login-form' onSubmit={handleSubmit}>
                <Box className='login-title' sx={{ mb: 3 }}>
                  <Typography
                    color="textPrimary"
                    variant="h2"
                  >
                    <span style={{color: '#6b778c', fontSize: '18px', display: 'block'}}>
                      &#128274; Đăng nhập
                    </span>
                    <span style={{color: '#FF0000', fontSize: '24px', fontWeight: 'bold', fontStyle: 'italic', fontFamily: 'Consolas', marginTop: '10px', display: 'block'}}>
                      Hệ thống nạp tiền
                    </span>
                  </Typography>
                </Box>
                <TextField
                  className='login-component'
                  error={Boolean(touched.username && errors.username)}
                  fullWidth
                  helperText={touched.username && errors.username}
                  label="Tài khoản"
                  margin="normal"
                  name="username"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="username"
                  value={values.username}
                  variant="outlined"
                />
                <TextField
                  className='login-component'
                  error={Boolean(touched.password && errors.password)}
                  fullWidth
                  helperText={touched.password && errors.password}
                  label="Mật khẩu"
                  margin="normal"
                  name="password"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type="password"
                  value={values.password}
                  variant="outlined"
                />
                <Box 
                  className='login-component'
                  sx={{ py: 2 }}
                >
                  <Button
                    color="primary"
                    disabled={isSubmitting}
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                  >
                    Đăng nhập
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Box>
    </>
  );
};

export default Login;
